import { routes as signature } from './signature'
import { routes as hour } from './hour'
import { routes as occurrence } from './occurrence'
import { routes as grid } from './grid'
import { routes as communication } from './communication'
import { routes as integration } from './integration'
import { routes as course } from './course'
import { routes as dynamics } from './dynamics'
import { routes as teacher } from './teacher'
import { routes as agent } from './agent'
import { routes as arp } from './arp'
import { routes as cenarioCatalogo } from './cenario-catalogo'

export default [
    ...signature,
    ...hour,
    ...grid,
    ...integration,
    ...occurrence,
    ...communication,
    ...teacher,
    ...course,
    ...dynamics,
    ...agent,
    ...arp,
    ...cenarioCatalogo,
]